import { rem } from '../../utils/style';
import styled from 'styled-components';
import { COLORS } from '../../constants/style/color';
import { type ReactNode } from 'react';

interface RadioButtonWrapperType {
  label?: string | ReactNode;
}

export const RadioButtonWrapper = styled.div<RadioButtonWrapperType>`
  position: relative;
  display: flex;
  gap: 17px;
  min-width: ${rem(20)};
  align-items: center;
  &.partialSelect {
    input[type='checkbox']::after {
      position: absolute;
      content: '\\e15b';
      color: ${COLORS.White};
      font-size: ${rem(16)};
      background-color: ${COLORS.SpanishGray};
      width: ${rem(18)};
      height: ${rem(18)};
      border-radius: ${rem(3)};
      font-family: 'Material Symbols Rounded';
      /* font-weight: 900; */
      line-height: ${rem(19)};

      display: flex;
      justify-content: center;

      left: 0px;
      top: 0px;
    }
  }
  &.radioCheckbox {
    input[type='radio']::before {
      position: absolute;
      content: '';
      width: ${rem(18)};
      height: ${rem(18)};
      border: ${rem(1)} solid ${COLORS.LightGray};
      border-radius: ${rem(4)};
      background-color: ${COLORS.White};
      top: 9px;
      left: 9px;
      transform: translate(-50%, -50%);
      cursor: pointer;
      transition: 0.3s all linear;
    }

    input[type='radio']:checked::after {
      position: absolute;
      content: '\f88b';
      color: ${COLORS.White};
      font-size: ${rem(18)};
      background-color: ${COLORS.Green};
      width: ${rem(18)};
      height: ${rem(18)};
      border-radius: ${rem(4)};
      font-family: 'Material Symbols Outlined';
      font-weight: 900;
      line-height: ${rem(19)};
      transition: 0.3s all linear;

      display: flex;
      justify-content: center;

      left: 0px;
      top: 0px;
      transform: none;
    }
  }
  input {
    width: 1px;
    height: 1px;
    -moz-appearance: initial;
    -webkit-appearance: none;
    appearance: none;
  }

  input[type='radio'],
  input[type='checkbox'] {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
  }

  /* input[type='checkbox'] {
    -webkit-appearance: caret;
  } */

  input[type='radio']::before {
    position: absolute;
    content: '';
    width: ${rem(18)};
    height: ${rem(18)};
    border: ${rem(1)} solid ${COLORS.LightGray};
    border-radius: 50%;
    background-color: ${COLORS.White};
    top: 11px;
    left: 9px;
    transform: translate(-50%, -50%);
    cursor: pointer;
    transition: 0.3s all ease;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }

  input[type='radio']:disabled::before {
    background-color: ${COLORS.OffWhite};
  }

  input[type='radio']:checked::before {
    border: ${rem(1)} solid ${COLORS.Green};
  }

  input[type='radio']:checked::after {
    position: absolute;
    content: '';

    width: ${rem(10)};
    height: ${rem(10)};
    border-radius: 50%;
    background-color: ${COLORS.Green};
    top: 11px;
    left: 9px;
    transform: translate(-50%, -50%);
    -webkit-transform: translate(-50%, -50%);
  }

  input[type='checkbox']::before {
    position: absolute;
    content: '';
    width: ${rem(18)};
    height: ${rem(18)};
    border: ${rem(1)} solid ${COLORS.LightGray};
    border-radius: ${rem(4)};
    background-color: ${COLORS.White};
    top: 9px;
    left: 9px;
    transform: translate(-50%, -50%);
    -webkit-transform: translate(-50%, -50%);
    cursor: pointer;
    transition: 0.3s all linear;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }

  input[type='checkbox']:checked::before {
    border: ${rem(1)} solid ${COLORS.Green};
    transition: 0.3s all linear;
  }

  input[type='checkbox']:checked::after {
    position: absolute;
    content: '\f88b';
    color: ${COLORS.White};
    font-size: ${rem(18)};
    background-color: ${COLORS.Green};
    width: ${rem(18)};
    height: ${rem(18)};
    border-radius: ${rem(4)};
    font-family: 'Material Symbols Outlined';
    font-weight: 900;
    line-height: ${rem(19)};
    transition: 0.3s all linear;

    display: flex;
    justify-content: center;
    -webkit-box-pack: center;

    left: 0px;
    top: 0px;
  }

  input[type='checkbox']:disabled::before {
    background-color: ${COLORS.OffWhite};
  }

  input[type='checkbox']:disabled::after {
    background-color: ${COLORS.SpanishGray};
  }

  label {
    margin-left: ${rem(6)};
    margin-bottom: 0;
    font-weight: 400;
    transition: 0.3s all linear;
  }

  input[type='checkbox'].is-invalid:not(:disabled)::before,
  input[type='radio'].is-invalid:not(:disabled)::before {
    border: ${rem(1)} solid ${COLORS.Red};
  }

  /* Safari-specific fixes */
  @supports (-webkit-touch-callout: none) {
    input[type='radio'],
    input[type='checkbox'] {
      position: relative;
      margin: 0;
      padding: 0;
    }

    input[type='radio']::before,
    input[type='checkbox']::before {
      margin: 0;
    }
  }
`;
